import { PropsWithChildren } from "react";
import "./InfoPopup.scss";
import { Close, Info } from "@/icons";
import { Button, Popover } from "@radix-ui/themes";
import clsx from "clsx";
import React from "react";

export type InfoPopupProps = PropsWithChildren<{
  title: string;
  description: string | React.ReactNode;
  isOpen?: boolean;
  onClickCloseBtn?: () => void;
  className?: string;
  positionPopUp?: "right" | "top" | "bottom" | "left" | undefined;
  width?: string;
  ariaLabel?: string;
}>;

export const InfoPopup = ({
  title = "Info",
  description,
  width = "15.5rem",
  className = "",
  positionPopUp = "right",
  onClickCloseBtn,
  isOpen,
  ariaLabel,
  children,
}: InfoPopupProps) => {
  return (
    <Popover.Root
      defaultOpen={false}
      open={isOpen}
      onOpenChange={onClickCloseBtn}
      modal={false}
    >
      <Popover.Trigger className="position-relative" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <Button
          className="ui-popup-trigger-button"
          aria-label={ariaLabel || title}
          title={ariaLabel || title}
        >
          <Info color="primary" />
        </Button>
      </Popover.Trigger>
      <Popover.Content
        className={clsx(className, "dialog")}
        side={positionPopUp}
        tabIndex={-1}
        width={{
          initial: width,
          sm: width,
          xs: width,
          lg: width,
          md: width,
          xl: width,
        }}
        maxWidth={{
          initial: width,
          sm: width,
          xs: width,
          lg: width,
          md: width,
          xl: width,
        }}
        minWidth={{
          initial: width,
          sm: width,
          xs: width,
          lg: width,
          md: width,
          xl: width,
        }}
        style={{ width: width }}
      >
        <div className="header">
          <h1 id="dialog-title" className="title">
            {title}
          </h1>

          <Popover.Close
            className="closeButton"
            aria-label="Close dialog"
            onClick={(e: any) => {
              e.stopPropagation();
              onClickCloseBtn?.();
            }}
          >
            <Close className="closeIcon" width={34} height={34} />
          </Popover.Close>
        </div>
        {description && (
          <div id="dialog-description" className="content">
            {description}
          </div>
        )}
        {children}
      </Popover.Content>
    </Popover.Root>
  );
};
